export const SENSOR_FITTER_URL =
  '/catalog/leakage-current-sensor';
export const SENSOR_SUBFITTER_URL =
  '/catalog/leakage-current-sensor';
export const PROBES_FITTER_URL =
  '/filters-probes';
export const PROBES_SUBFITTER_URL =
  '/subfilters-probes';
export const EL_OPER_FITTER_URL =
  '/catalog/el-oper-tok';
